import * as types from "./../../../../databse/types";

const initialState = {
    cards: JSON.parse(localStorage.getItem('shoppingCart')) !== null ? JSON.parse(localStorage.getItem('shoppingCart')) : [],
    apiCards: {},
    statusShow: false,
    statusAnimation: false,
    statusPrevAndNext: 'next',
    levelPayment: 'LIST_PRODUCTS',
    titleModalShoppingCard: 'سبد خرید',
    loaderListProducts: false,
    days: {},
    activeDayPostSchedule: '',
    activeSelectTablePostSchedule: {},
    questions: [],
    orderDescription: '',
    selectableQuestion: [],
    invoice: {},
    statusLoaderPrice: false,
    payTypeClick: 0,
    statusAddWalletItemInInvoice: false,

};
const modalShoppingCard = (state = initialState, action) => {
    switch (action.type) {
        case types.OPEN_MODAL_SHOPPING_CARD:
            return {...state, statusShow: true};
        case types.CLOSE_MODAL_SHOPPING_CARD:
            return {...initialState, cards: state.cards};
        case types.TOGGLE_ANIMATION_MODAL_SHOPPING_CARD:
            return {...state, statusAnimation: action.statusAnimation};
        case types.TOGGLE_ARROW_MODAL_SHOPPING_CARD:
            return {...state, statusPrevAndNext: action.statusPrevAndNext};
        case types.CHANGE_LEVEL_PAYMENT_SHOPPING_CARD:
            return {...state, levelPayment: action.levelPayment, titleModalShoppingCard: action.titleModalShoppingCard};
        case types.CHANGE_LOADER_LIST_PRODUCTS_MODAL_SHOPPING_CARD:
            return {...state, loaderListProducts: action.loaderListProducts};
        case types.CHANGE_API_CARDS_LIST_PRODUCTS_MODAL_SHOPPING_CARD:
            return {...state, apiCards: action.apiCards};
        case types.REMOVE_ALL_ITEM_IN_BASKET_CART:
            localStorage.removeItem('shoppingCart');
            return {...state, cards: [], apiCards: {}};
        case types.CHANGE_DAYS_SELECT_MODAL_SHOPPING_CARD:
            return {...state, days: action.days, activeDayPostSchedule: action.days.day_selected};
        case types.CHANGE_ACTIVE_DAY_POST_SCHEDULE:
            return {...state, activeDayPostSchedule: action.activeDayPostSchedule};
        case types.CHANGE_ACTIVE_SELECT_TABLE_POST_SCHEDULE:
            return {...state, activeSelectTablePostSchedule: action.activeSelectTablePostSchedule};
        case types.CHANGE_LIST_QUESTIONS:
            let listDefaultSelectedBtns = [];
            action.questions.map(item => {
                item.answers.map(answerItem => {
                    if (parseInt(answerItem.default) === 1)
                        listDefaultSelectedBtns.push({
                            question: item.title,
                            answerId: answerItem.id,
                            answerTitle: answerItem.title
                        });
                    return '';
                });
                return '';
            });
            return {...state, questions: action.questions, selectableQuestion: listDefaultSelectedBtns};
        case types.REFRESH_MODAL_SHOPPING_CARD:
            localStorage.removeItem('shoppingCart');
            return {...initialState, cards: []};
        case types.CHANGE_INPUTS_MODAL_SHOPPING_CARD:
            return {...state, [action.name]: action.value};
        case types.CHANGE_SELECTABLE_ITEM_QUESTION_MODAL_SHOPPING_CARD:
            const {question, answerId, answerTitle} = action.selectableQuestion;
            let newArray = state.selectableQuestion;
            let statusAdd = false;
            if (state.selectableQuestion.length === 0) {
                newArray.push({question, answerId, answerTitle});
            } else {
                for (const item in state.selectableQuestion) {
                    if (state.selectableQuestion[item].question === question) {
                        newArray = newArray.map(ans => {
                            return (ans.question === question) ? {question, answerId, answerTitle} : ans;
                        })
                        statusAdd = true;
                        break;
                    }
                }
                if (!statusAdd) {
                    newArray.push({question, answerId, answerTitle});
                }
            }
            return {...state, selectableQuestion: newArray};
        case types.HANDEL_CHANGE_INVOICE_MODAL_SHOPPING_CARD:
            const RESULT_ITEMS = Object.keys(action.invoice.items).map(key => {
                return action.invoice.items[key];
            })
            return {...state, invoice: {...action.invoice, items: RESULT_ITEMS}};
        case types.HANDEL_CHANGE_LOADER_PRICE_INVOICE:
            return {...state, statusLoaderPrice: action.statusLoaderPrice};
        case types.CHANGE_PAY_TYPE_CLICK_INVOICE:
            return {...state, payTypeClick: action.payTypeClick};
        case types.ADD_ITEM_IN_INVOICE:
            return {
                ...state, invoice: {
                    ...state.invoice,
                    items: [...state.invoice.items, action.item],
                    total_raw: Object.keys(action.item).toString() === 'تخفیف'  || Object.keys(action.item).toString() === 'پرداخت از کیف پول'
                        ? state.invoice.total_raw - parseInt(action.item[Object.keys(action.item)])
                        : state.invoice.total_raw + action.item[Object.keys(action.item)]
                }
            };
        /*let stateInvoiceItems = {};
        let wallet_credit = 0;
        let state_base_total_raw = 0;
        if (action.item.REMOVE_ITEM === 'PRICE_WALLET') {
            Object.keys(state.invoice.items).forEach(key => {
                if (key === 'PRICE_WALLET') {
                    wallet_credit = state.invoice.items[key][Object.keys(state.invoice.items[key])];
                    state_base_total_raw = (state.invoice.total_raw + wallet_credit);
                } else {
                    stateInvoiceItems = {...stateInvoiceItems, [key]: state.invoice.items[key]};
                }
            });
        }

        return action.item.REMOVE_ITEM === 'PRICE_WALLET'
            ? {
                ...state,
                invoice: {
                    ...state.invoice, items: stateInvoiceItems, wallet_credit,
                    total_raw: state_base_total_raw
                },
                statusAddWalletItemInInvoice: false,
            }
            : {
                ...state,
                invoice: {
                    ...state.invoice,
                    items: {...state.invoice.items, PRICE_WALLET: action.item},
                    wallet_credit: 0,
                    total_raw: state.invoice.total_raw - action.item['پرداخت از کیف پول'],
                },
                statusAddWalletItemInInvoice: true,
            };*/
        case types.REMOVE_ITEM_IN_INVOICE:
            const RESULT_TOTAL_ROW = typeof action.count === 'string' ? parseInt(action.count) : action.count;
            return {
                ...state, invoice: {
                    ...state.invoice,
                    items: [...state.invoice.items.filter(item => {
                        return Object.keys(item).toString() !== action.item ? item : null
                    })],
                    total_raw: action.item === 'تخفیف'  || action.item === 'پرداخت از کیف پول'
                        ? state.invoice.total_raw + RESULT_TOTAL_ROW
                        : state.invoice.total_raw - RESULT_TOTAL_ROW
                }
            };
        default:
            return state;
    }
};

export default modalShoppingCard;
